module.exports = __webpack_public_path__ + "static/media/maintaining-the-standard.54f7a7b9.jpg";